/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var React = require('react');
var ReactTransitionEvents = require('react/lib/ReactTransitionEvents');
var Router = require('react-router');
var $__0=     require('./Defs'),CallSigDef=$__0.CallSigDef,MemberDef=$__0.MemberDef;
var PageDataMixin = require('./PageDataMixin');
var isMobile = require('./isMobile');
var MarkDown = require('./MarkDown');

var $__1=    React.addons,TransitionGroup=$__1.TransitionGroup;

var MemberDoc = React.createClass({displayName: "MemberDoc",
  mixins: [PageDataMixin, Router.Navigation],

  getInitialState:function() {
    var showDetail = this.props.showDetail;
    return { detail: showDetail };
  },

  componentDidMount:function() {
    if (this.props.showDetail) {
      var node = this.getDOMNode();
      var navType = this.getPageData().type;
      if (navType === 'init' || navType === 'push') {
        window.scrollTo(window.scrollX, offsetTop(node) - FIXED_HEADER_HEIGHT);
      }
    }
  },

  componentWillReceiveProps:function(nextProps) {
    if (nextProps.showDetail && !this.props.showDetail) {
      this.scrollTo = true;
      this.setState({ detail: true });
    }
  },

  componentDidUpdate:function() {
    if (this.scrollTo) {
      this.scrollTo = false;
      var node = this.getDOMNode();
      var navType = this.getPageData().type;
      if (navType === 'init' || navType === 'push') {
        window.scrollTo(window.scrollX, offsetTop(node) - FIXED_HEADER_HEIGHT);
      }
    }
  },

  toggleDetail:function() {
    // Note: removed this because it drops the URL bar on mobile, and that's
    // the only place it's currently being used.
    // var member = this.props.member;
    // var name = member.memberName;
    // var typeName = this.props.parentName;
    // var showDetail = this.props.showDetail;
    // if (!this.state.detail) {
    //   this.replaceWith('/' + (typeName ? typeName + '/' : '') + name );
    // } else if (this.state.detail && showDetail) {
    //   this.replaceWith('/' + (typeName || '') );
    // }
    this.setState({ detail: !this.state.detail });
  },

  render:function() {
    var typePropMap = this.props.typePropMap;
    var member = this.props.member;
    var module = member.isStatic ? this.props.parentName : null;
    var name = member.memberName;
    var def = member.memberDef;
    var doc = def.doc || {};
    var isProp = !def.signatures;

    var typeInfo = member.inherited && {
      propMap: typePropMap,
      defining: member.inherited.name,
    };

    var showDetail = isMobile ? this.state.detail : true;

    var memberAnchorLink = this.props.parentName + '/' + name;

    return (
      React.createElement("div", {className: "interfaceMember"}, 
        React.createElement("h3", {className: "memberLabel"}, 
          React.createElement(Router.Link, {
            to: '/' + memberAnchorLink, 
            onClick: isMobile ? this.toggleDetail : null
          }, 
            (module ? module + '.' : '') + name + (isProp ? '' : '()')
          )
        ), 
        React.createElement(TransitionGroup, {childFactory: makeSlideDown}, 
          showDetail && (
            React.createElement("div", {key: "detail", className: "detail"}, 
              doc.synopsis && (
                React.createElement(MarkDown, {className: "synopsis", contents: doc.synopsis})
              ), 
              isProp ? (
                React.createElement("code", {className: "codeBlock memberSignature"}, 
                  React.createElement(MemberDef, {
                    module: module, 
                    member: { name:name, type: def.type}}
                  )
                )
              ) : (
                React.createElement("code", {className: "codeBlock memberSignature"}, 
                  def.signatures.map(function(callSig, i)  {return [
                    React.createElement(CallSigDef, {
                      key: i, 
                      info: typeInfo, 
                      module: module, 
                      name: name, 
                      callSig: callSig}
                    ),
                    '\n',
                  ];})
                )
              ), 
              member.inherited && (
                React.createElement("section", null, 
                  React.createElement("h4", {className: "infoHeader"}, "Inherited from"), 
                  React.createElement("code", null, 
                    React.createElement(Router.Link, {to: '/' + member.inherited.name + '/' + name}, 
                      member.inherited.name + '#' + name
                    )
                  )
                )
              ), 
              member.overrides && (
                React.createElement("section", null, 
                  React.createElement("h4", {className: "infoHeader"}, "Overrides"), 
                  React.createElement("code", null, 
                    React.createElement(Router.Link, {to: '/' + member.overrides.name + '/' + name}, 
                      member.overrides.name + '#' + name
                    )
                  )
                )
              ), 
              doc.notes &&
                doc.notes.map(function(note, i)  
                  {return React.createElement("section", {key: i}, 
                    React.createElement("h4", {className: "infoHeader"}, note.name), 
                    note.name === 'alias' ? (
                      React.createElement("code", null, 
                        React.createElement(CallSigDef, {name: note.body})
                      )
                    ) : (
                      React.createElement(MarkDown, {className: "discussion", contents: note.body})
                    )
                  );}
                ), 
              doc.description && (
                React.createElement("section", null, 
                  React.createElement("h4", {className: "infoHeader"}, 
                    doc.description.substr(0, 5) === '<code'
                      ? 'Example'
                      : 'Discussion'
                  ), 
                  React.createElement(MarkDown, {className: "discussion", contents: doc.description})
                )
              )
            )
          )
        )
      )
    );
  },
});

function makeSlideDown(child) {
  return React.createElement(SlideDown, null, child);
}

var SlideDown = React.createClass({displayName: "SlideDown",
  componentWillEnter:function(done) {
    this.slide(false, done);
  },

  componentWillLeave:function(done) {
    this.slide(true, done);
  },

  slide:function(slidingUp, done) {
    var node = this.getDOMNode();
    node.style.height = 'auto';
    var height = getComputedStyle(node).height;
    var start = slidingUp ? height : 0;
    var end = slidingUp ? 0 : height;
    node.style.transition = '';
    node.style.height = start;
    node.style.transition = 'height 0.35s ease-in-out';
    var endListener = function()  {
      ReactTransitionEvents.removeEndEventListener(node, endListener);
      done();
    };
    ReactTransitionEvents.addEndEventListener(node, endListener);
    this.timeout = setTimeout(function()  {
      node.style.height = end;
    }, 17);
  },

  render:function() {
    return this.props.children;
  },
});

var FIXED_HEADER_HEIGHT = 75;

function offsetTop(node) {
  var top = 0;
  do {
    top += node.offsetTop;
  } while ((node = node.offsetParent));
  return top;
}

module.exports = MemberDoc;
